import styled from 'styled-components'

export const TranscriptionAuthorizerDisclaimerModalContainer = styled.div`
  > p {
    line-height: 25px;
  }

  div p {
    padding-top: 20px;
  }
`

export const ButtonsWrapper = styled.div`
  margin-top: 30px;
  display: flex;
  justify-content: center;
  gap: 15px;

  button {
    width: 100%;
    border-radius: 9999px;

    &:first-child {
      width: 35%;
      color: #4b4b4b;
      border-color: #4b4b4b;

      &:hover {
        background-color: #f6f6f6;
      }
    }
  }
`